export const uk = {
    no: 'Нет',
    yes: 'Да'
};
